import { TILE_SIZES, type TileSize } from '../constants.ts';
import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from '../styles/styles.scss';

export const useTileSizeClassNames = ({
    size,
}: {
    size: TileSize;
}): {
    tileSizeClassNames: string;
    productImageClassNames: string;
} => {
    return {
        tileSizeClassNames: classnames({
            [styles.tileSmall]: size === TILE_SIZES.small,
            [styles.tileMedium]: size === TILE_SIZES.medium,
            [styles.tileLarge]: size === TILE_SIZES.large,
            [dibsCss.hFull]: size === TILE_SIZES.auto || size === TILE_SIZES.autoImageLarge,
        }),
        productImageClassNames: classnames({
            [styles.productImageSmall]: size === TILE_SIZES.small,
            [styles.productImageMedium]: size === TILE_SIZES.medium,
            [styles.productImageLarge]:
                size === TILE_SIZES.large || size === TILE_SIZES.autoImageLarge,
        }),
    };
};
